import React, { Fragment } from 'react';
import {flowRight as compose} from 'lodash';
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import { withStyles } from '@material-ui/core/styles';

import { translate } from 'react-admin';

const styles = {
    listItemText: {
        marginLeft: '-15px',
        paddingLeft: 0,
    },
    sidebarIsOpen: {
        paddingLeft: 25,
        transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
    },
    sidebarIsClosed: {
        paddingLeft: 0,
        transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
    },
};

const SubMenu = ({
    handleToggle,
    sidebarIsOpen,
    isOpen,
    name,
    icon,
    classes,
    children,
}) => (
    <Fragment>
        <ListItem
            button
            onClick={handleToggle}
            className={classes.listItem}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText
                primary={isOpen ? name : ''}
                secondary={isOpen ? '' : name}
                className={classes.listItemText}
            />
            <ListItemIcon>{isOpen ? <ExpandMore /> : <ExpandLess />}</ListItemIcon>
        </ListItem>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List
                dense
                component="div"
                disablePadding
                className={
                    sidebarIsOpen
                        ? classes.sidebarIsOpen
                        : classes.sidebarIsClosed
                }
            >
                {children}
            </List>
        </Collapse>
    </Fragment>
);

const enhance = compose(
    withStyles(styles),
    translate
);

export default enhance(SubMenu);